import { toast } from "react-toastify";
import { HealthRule } from "models/health-rule";

// API only: the page dispatches setRules / setRule after these resolve.
const BASE = `${process.env.REACT_APP_API_URL}/health-rules`;

export const getHealthRules = async (): Promise<HealthRule[] | null> => {
    try {
        const res = await fetch(BASE, { credentials: 'include', method: 'GET' });
        if (!res.ok) {
            const errBody = await res.json().catch(() => null);
            throw new Error(errBody?.message ?? "Error getting health rules");
        }
        return (await res.json()).data as HealthRule[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting health rules");
        return null;
    }
}

export const getHealthRuleHistory = async (key: string): Promise<HealthRule[] | null> => {
    try {
        const res = await fetch(`${BASE}/${encodeURIComponent(key)}/history`, { credentials: 'include', method: 'GET' });
        if (!res.ok) {
            const errBody = await res.json().catch(() => null);
            throw new Error(errBody?.message ?? "Error getting rule history");
        }
        return (await res.json()).data as HealthRule[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting rule history");
        return null;
    }
}

export const submitHealthRuleValue = async (key: string, value: number): Promise<HealthRule | null> => {
    try {
        const res = await fetch(`${BASE}/${encodeURIComponent(key)}`, {
            credentials: 'include',
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ value }),
        });
        if (!res.ok) {
            const errBody = await res.json().catch(() => null);
            throw new Error(errBody?.message ?? "Error updating rule");
        }
        toast.success("Rule updated. A new version is now in effect.");
        return (await res.json()).data as HealthRule;
    } catch (err: any) {
        toast.error(err.message ?? "Error updating rule");
        return null;
    }
}
